module.exports = __webpack_public_path__ + "static/media/Sny.2687fd3f.mp3";